import { createAction } from "redux-actions";

const ns = "TOPIK";

// Helper: build a request/success/error action triple under a namespaced path.
const triple = (path) => ({
  request: createAction(`${ns}/${path}/REQUEST`),
  success: createAction(`${ns}/${path}/SUCCESS`),
  error: createAction(`${ns}/${path}/ERROR`),
});

export const session = {
  get: triple("SESSION/GET"),
};

export const comparisons = {
  // Q1 renamed likely -> generality (endpoint comparisons/generality; §6.0 rename).
  generality: triple("COMPARISONS/GENERALITY"),
  outcome: triple("COMPARISONS/OUTCOME"),
};

export const analysis = {
  observation: triple("ANALYSIS/OBSERVATION"),
  seriousness: triple("ANALYSIS/SERIOUSNESS"),
  issues: triple("ANALYSIS/ISSUES"),
  risk: triple("ANALYSIS/RISK"),
  solution: triple("ANALYSIS/SOLUTION"),
  // The voluntary stop/continue gate (§6.2a a).
  continue: triple("ANALYSIS/CONTINUE"),
  // Continue-branch elaborations (§6.2a b).
  riskMitigation: triple("ANALYSIS/RISK_MITIGATION"),
  solutionMaximizer: triple("ANALYSIS/SOLUTION_MAXIMIZER"),
  // Terminal goal step (§6.2a c).
  goal: triple("ANALYSIS/GOAL"),
  // Backtracking within the analysis phase (§6.3).
  back: triple("ANALYSIS/BACK"),
};

// Graduated AI step companion (§6.5): POST a step's draft at its next ladder level (request),
// poll the async result, or restore the latest result after a reload/rejoin. The saga owns
// the poll loop; `poll` success ticks update the per-step slice.
export const aiAssist = {
  request: triple("AI_ASSIST/REQUEST"),
  poll: triple("AI_ASSIST/POLL"),
  restore: createAction(`${ns}/AI_ASSIST/RESTORE`),
};
